import classes from "./PaymentError.module.scss";
import { useState, useEffect, useContext } from "react";
import PaymentErrorImg from "./../../../../../../assets/images/credit_card_error.svg";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import SystemContext from "../../../../../../context/SystemContext";
import { useTranslation } from "react-i18next";

const PaymentError = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { PurchaseInfo,changePropertyUrl } = useContext(SystemContext);
  const [PaymentDesc, setPaymentDesc] = useState();
  const payload = useSelector((state) => state.purchase);
  const [currentError, setCurrentError] = useState(null);

  const handleBackPayment = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "PaymentArea",
        step: "CreditCard",
      },
    });
  };

  useEffect(() => {
      changePropertyUrl("",{etapa:"error"});

  }, []);

  const handleReload = () => {
    // window.location.reload()
    dispatch({
      type: "PURCHASE",
      purchase: {
        content:"PaymentArea",
        step: "InvoiceData",
      },
      PostData: {
        invoice_info:payload.PostData.invoice_info
      }
    });
  };
  
  const MapServerError = {
    "Product not allowed": {
      title: "purchase.plan_already_purchased",
      image: PaymentErrorImg,
      description: "purchase.you_already_have_an_active",
      btnText: "purchase.to_go_back",
      btnAction: handleReload
    },
    "No permission to one or more of the products in the shopping cart.": {
      title: "purchase.plan_not_found",
      image: PaymentErrorImg,
      description:
        "purchase.the_plan_you_tried_to_purchase_is_no_longer_available",
        btnText: "purchase.update_page",
      btnAction: handleReload
    },
    "Failure to create Pix, try again later.": {
      title: "purchase.failed_to_create_pix",
      image: PaymentErrorImg,
      description:
        "purchase.there_was_an_error_generating_payment_via_pix",
        btnText: "purchase.try_again",
      btnAction: handleBackPayment
    },
    "Another Payment in Process. Please try again later.": {
      title: "purchase.error_processing_card",
      image: PaymentErrorImg,
      description:
        "purchase.there_was_a_failure_processing_payment_information",
        btnText: "purchase.try_again",
      btnAction: handleBackPayment
    },
    "Compra recusada Cartao":{
      title: "purchase.error_processing_payment_card",
      image: PaymentErrorImg,
      description: "purchase.there_was_a_failure_processing_payment_information_card",
      btnText: "purchase.try_again",
      btnAction: handleBackPayment
    },
    Default: {
      title: "purchase.error_processing_payment",
      image: PaymentErrorImg,
      description: "purchase.please_check_if_your_data",
      btnText: "purchase.to_go_back",
      btnAction: handleReload
    },
  };

  useEffect(() => {
    if (payload && payload.purchase && payload.purchase.message) {
      const error = MapServerError.hasOwnProperty(payload.purchase.message)
          ? MapServerError[payload.purchase.message]
          : MapServerError["Default"]
      setCurrentError(
        error
      );
      window.dataLayer.push({
        event: "checkout_error", // Nome do evento que você vai criar
        error_message: error.title, // Ex: "Cartão recusado pelo banco" ou "Saldo insuficiente"
        error_code: payload.errorCode,       // Ex: "402", "500", etc. (se houver)
        error_step: "pagamento"              // A etapa onde o erro ocorreu
      });
    }
  }, [payload]);

  

  useEffect(() => {
    if (
      PurchaseInfo.MethodChosen === "CreditCard" ||
      PurchaseInfo.MethodChosen === "OldCards"
    ) {
      setPaymentDesc("Cartão de Crédito");
    } else if (PurchaseInfo.MethodChosen === "DescPix") {
      setPaymentDesc("PIX");
    }

    // console.log("PaymentDesc", PaymentDesc);
  }, [PurchaseInfo.MethodChosen]);

  const theme = createTheme({
    palette: {
      ochre: {
        main: "#662D91",
        light: "#662D91",
        dark: "#430d6c",
        contrastText: "#FFF",
      },
      ochreBack: {
        main: "#FFF",
        light: "#FFF",
        contrastText: "#787676",
      },
    },
  });
  const mapReplaceTags = {
    "[PAYMENT_METHOD]":PaymentDesc
  }

  const normalize_tags_in_text = (text) => {
    return Object.keys(mapReplaceTags).reduce((finalText,keyTest)=>finalText.replace(keyTest,mapReplaceTags[keyTest]),text)
  }

  return (
    currentError && (
      <div className={classes.PaymentError}>
        <img className={classes.Image} src={currentError["image"]} alt="" />
        <div className={classes.Title}>{normalize_tags_in_text(t(currentError["title"]))}</div>
        <div className={classes.Description}>
          {normalize_tags_in_text(t(currentError["description"]))}
        </div>
        <ThemeProvider theme={theme} style={{ margin: "20px 0" }}>
          <Button
            onClick={currentError["btnAction"]}
            className={classes.Button}
            variant="contained"
            color="ochre"
          >
            {t(currentError["btnText"])}
          </Button>
        </ThemeProvider>
      </div>
    )
  );
};
export default PaymentError;
